module.exports = __webpack_public_path__ + "img/dweekiy_300A.69365863.png";